<template>
	<div>
		<div class="clear"></div>
		<div class="header">
			<div class="w1200 bc">
				<a class="logo fl" href="#" title="云永云商城"></a>
				<div class="search">
					<span class="ico"></span>
					<input class="text" type="text" placeholder="Please enter a keyword">
					<button class="btn">Search</button>
				</div>
				<div class="r-box fr">
					<div class="mycart">
						<i class="ico-cart"></i>
						<a href="#">My Shopping Cart</a>
						<span class="ico-shopping-amount">0</span>
						<i class="ico-r"></i>
						<div class="goods-list none" style="display: none;">
							<div class="spacer"></div>
							<!--没选商品-->
							<div class="no-goods">
								<img src="../../static/images/settleup-nogoods.png" width="57" height="49">There are no products in the shopping cart, so buy it now!
							</div>
							<!--已选商品-->
							<div class="mylist">
								<h4>Latest additions</h4>
								<ul>
									<li class="li-1"><span class="fr">小计：￥599.00</span></li>
									<li class="li-2">
										<a class="fl spic" href="#"><img src="../../static/images/temp/zcjy-1.jpg" width="50" height="50"></a>
										<p class="name">
											<a href="#">一种超硬物料自动破碎装置物料自动破碎装置</a>
										</p>
										<p class="other"><span>￥599.00×1</span><br>
											<a class="del" href="#">删除</a>
										</p>
									</li>
								</ul>
								<div class="fbar"><span class="fl ml10">共2件商品　共计<b>￥ 738.00</b></span>
									<a class="fr gobuy" href="#">去购物车</a>
								</div>
							</div>
						</div>
					</div>
						<div class="mycart ml25">
							<i class="ico-orders"></i>
							<a @click="goOrder('')">My Order <span class="ico-shopping-amount">{{ allCount }}</span></a></a>
							<i class="ico-r"></i>
							<div class="goods-list orders">
                		<ul>
                    		<li><a href="javascript:void(0)" @click="goOrder('wait_buyer_pay')">Waiting for buyers payment <span class="ico-shopping-amount" style="text-align: center;">{{ payCount }}</span></a></li>
                        	<li><a href="javascript:void(0)" @click="goOrder('wait_send_goods')">Waiting for seller to ship <span class="ico-shopping-amount" style="text-align: center;">{{ sendCount }}</span></a></li>
                        	<li><a href="javascript:void(0)" @click="goOrder('wait_buyer_confirm_goods')">Wait for confirmation of receipt <span class="ico-shopping-amount" style="text-align: center;">{{ putCount }}</span></a></li>
                        	<li><a href="javascript:void(0)" @click="goOrder('trade_finish')">Order completed <span class="ico-shopping-amount" style="text-align: center;">{{ receiveCount }}</span></a></li>
                        	<li><a href="javascript:void(0)" @click="goOrder('trade_close')">Order closed <span class="ico-shopping-amount" style="text-align: center;">{{ closeCount }}</span></a></li>
                    	</ul>
                		</div>
						</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'emallheader',
		data() {
			return {
				msg: 'Welcome to Your Vue.js App123'
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/EmallHeader.vue